import { render, staticRenderFns } from "./TextFieldCurrency.vue?vue&type=template&id=476f5e6c&scoped=true&"
import script from "./TextFieldCurrency.vue?vue&type=script&lang=js&"
export * from "./TextFieldCurrency.vue?vue&type=script&lang=js&"
import style0 from "./TextFieldCurrency.vue?vue&type=style&index=0&id=476f5e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f5e6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
